import { handleActions } from 'redux-actions';
import { fromJS , List} from 'immutable';

import actions from '@synergycms_app/store/actions';

const systemActions = actions.system;


const system = handleActions(
  {
    [systemActions.get.toString()]: (store, action) => {
      return fromJS(action.payload);
    }
  },
  List()
);


export default system;
